export default "__VITE_ASSET__Dn6aq2qy__"